import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

const claimEnglishIqV1DataSchema = z.object({
  claimedAttemptCount: z.number().int().nonnegative(),
  latestShareId: z.string().nullable(),
  levelUpdated: z.boolean(),
});

export type IClaimEnglishIqV1Data = z.infer<typeof claimEnglishIqV1DataSchema>;

export const claimEnglishIqV1ResponseSchema: z.ZodSchema<IAPI<IClaimEnglishIqV1Data>> =
  createApiResponseSchema(claimEnglishIqV1DataSchema) as z.ZodSchema<IAPI<IClaimEnglishIqV1Data>>;

export type IClaimEnglishIqV1Response = IAPI<IClaimEnglishIqV1Data>;
